import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCloseWhite = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 32,
	height: 31,
	viewBox: "0 0 32 31",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("rect", {
			width: 2.36341,
			height: 30.7244,
			rx: 1.18171,
			transform: "matrix(0.711512 -0.702674 0.711512 0.702674 4.45776 5.53589)",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: 2.36341,
			height: 30.7244,
			rx: 1.18171,
			transform: "matrix(0.711512 0.702674 -0.711512 0.702674 25.8608 3.875)",
			fill: "white"
		})
	]
});
const ForwardRef = forwardRef(SvgCloseWhite);
export { ForwardRef as ReactComponent };
